<div class="display-flex flex-column grid-gap-4" [formGroup]="form">
  <app-radio-button
    formControlName="fileOption"
    [items]="fileOptions"
    [radioGroupClass]="'display-flex flex-column'"
    [optionCss]="'body'"></app-radio-button>
</div>
